import React, { FC } from 'react';
import DevLogsPage from './dev-logs';
import { Route, Routes } from 'react-router-dom';

const DevLogsIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<DevLogsPage />} />
    </Routes>
  );
};

export default DevLogsIndex;
